import React, { Fragment } from "react"
import Layout from "../components/layout"
import Projects from "../components/projects"
import { StyledButton } from "../components/globalStyles"
const IndexPage = () => (
  <Layout>
    <Projects />
    <div style={{ margin: "30px" }}>
      <form action="/projectList">
        <StyledButton to="/projectList">other Projects...</StyledButton>
      </form>
    </div>
  </Layout>
)

export default IndexPage
